__webpack_require__.p = "//jiangben-frontendstaticcdn.soke.cn/ai-coach.soke.cn/home/build/";